<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.homeSections.edit") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.homeSections.titleAr')"
            v-model.trim="data.titleAr"
            required
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.homeSections.titleEn')"
            v-model.trim="data.titleEn"
            required
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('MESSAGES.sort')"
            v-model.number="data.order"
            required
          />

          <div class="input_wrapper switch_wrapper my-5 col-lg-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            />
          </div>

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import BaseImageUploadInput from "@/components/formInputs/BaseImageUploadInput.vue";

export default {
  name: "EditHomeSection",

  components: { BaseImageUploadInput },

  data() {
    return {
      isWaitingRequest: false,
      data: {
        image: {
          path: null,
          file: null,
        },
        titleAr: null,
        titleEn: null,
        order: null,
        active: true,
      },
    };
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    fillSectionData(section) {
      this.data.image.path = section.image || null;
      this.data.titleAr = section.title_ar || section.title;
      this.data.titleEn = section.title_en;
      this.data.order = section.order;
      this.data.active =
        section.is_active === undefined ? true : !!section.is_active;
    },

    async getSectionData() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "home-sections",
          params: {
            page: 0,
            limit: 0,
          },
        });

        const sectionId = Number(this.$route.params.id);
        const section = (res.data.data.data || []).find(
          (item) => Number(item.id) === sectionId
        );

        if (!section) {
          this.$message.error(this.$t("TABLES.noData"));
          this.$router.push({ path: "/home-sections/all" });
          return;
        }

        this.fillSectionData(section);
      } catch (error) {
        this.$message.error(error.response?.data?.message);
      }
    },

    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.titleAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      }

      if (!this.data.titleEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      }

      if (this.data.order === null || this.data.order === "") {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.homeSectionOrder"));
        return;
      }

      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();

      REQUEST_DATA.append("title[ar]", this.data.titleAr);
      REQUEST_DATA.append("title[en]", this.data.titleEn);
      REQUEST_DATA.append("order", this.data.order);
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `home-sections/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/home-sections/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response?.data?.message);
      }
    },
  },

  created() {
    this.getSectionData();
  },
};
</script>
